<!--
 * @Date: 2020-08-24 09:39:34
 * @Author: MX
 * @LastEditTime: 2021-03-26 15:58:36
 * @Description:
-->
<template>
  <div>
    <el-dialog lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :title="$lang('赔偿上限声明')"
      :visible="infoVisible"
      @close="hideDialog"
      width="35%">
      <p style="margin-top:0">{{$lang('赔偿上限服务费收取标准')}}：</p>
      <table border="1" cellspacing="0" cellpadding="0">
          <tr>
              <td>{{$lang('物品价值')}}</td>
             <td>{{$lang('赔偿上限服务费')}}</td>
          </tr>
          <tr>
              <td>{{$lang('物品价值')}} < 3000元</td>
             <td>{{$lang('不收取赔偿上限服务费')}}</td>
          </tr>
          <tr>
              <td>3000元 ≤ {{$lang('物品价值')}} ≤ 10000元</td>
             <td>{{$lang('物品价值')}} * 3‰</td>
          </tr>
          <tr>
              <td>10000元 ＜ {{$lang('物品价值')}} ≤ 30000元</td>
             <td>{{$lang('物品价值')}} * 5‰</td>
          </tr>
      </table>
      <p>{{$lang('其他说明')}}：</p>
       <p class="tips-info">
           {{$lang('1.寄件人对托寄物声明价值并缴纳相应的赔偿上限服务费，当快件在运输途中由于我司原因发生破损、丢失，我司将按照申报价值和货物实际损失比例进行赔偿，赔偿金额不超过快件申报价值')}}。
       </p>
       <p>{{$lang('2.价值3000元人民币（含）以上托寄物请选择赔偿上限服务，单件物品申报价值最高不得超出3万元。若未选择赔偿上限服务，则按货物实际损失赔偿，最高赔付3000元人民币')}}。
       </p>
       <p>{{$lang('3.合同、发票、证券等无法核定价值的文件类货物不支持投保')}}。</p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'InsuredStatement',
  data() {
    return {
    }
  },
  props: {
    infoVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hideDialog() {
      this.$emit('closeInsured')
    },
  },
}
</script>
<style lang="scss" scoped>
  .tip-box{
    margin-bottom: 40px;
    .tips-info{
      line-height: 20px;
      margin-top: 0;
      margin-bottom: 25px;
    }
  }
  table{
      border-color: #999;
      text-align: center;
      width: 100%;
      td{
          padding: 10px 0;
      }
  }
</style>
